export const SAVE_PHFOOD = 'SAVE_PHFOOD';
export const DELETE_PHFOOD = 'DELETE_PHFOOD';
export const PH_ADD_WEIGHT = 'PH_ADD_WEIGHT';

export const SAVE_GIS_FOOD = 'SAVE_GIS_FOOD';
export const DELETE_GIS_FOOD = 'DELETE_GIS_FOOD';
export const GIS_ADD_WEIGHT = 'GIS_ADD_WEIGHT';

export const SAVE_CARBO_FOOD_AFTER = 'SAVE_CARBO_FOOD_AFTER';
export const DELETE_CARBO_FOOD_AFTER = 'DELETE_CARBO_FOOD_AFTER';
export const CARBOAFTER_ADD_WEIGHT = 'CARBOAFTER_ADD_WEIGHT';


export const SAVE_CARBO_FOOD_BEFORE = 'SAVE_CARBO_FOOD_BEFORE';
export const DELETE_CARBO_FOOD_BEFORE = 'DELETE_CARBO_FOOD_BEFORE';
export const CARBOBEFORE_ADD_WEIGHT = 'CARBOBEFORE_ADD_WEIGHT';


// WEBPACK FOOTER //
// ./src/store/mutation-types.js